import { Component, HostBinding, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FormControl } from '@angular/forms';
import { OverlayContainer } from '@angular/cdk/overlay';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: '<router-outlet />',
})
export class AppComponent implements OnInit {
  switchTheme = new FormControl(false);

  @HostBinding('class') class = '';
  darkClass = 'dark-theme';
  lightClass = 'light-theme';

  constructor(private overlay: OverlayContainer) {}

  ngOnInit(): void {
    this.switchTheme.valueChanges.subscribe((value) => {
      this.class = value ? this.darkClass : this.lightClass;

      if (value) {
        this.overlay.getContainerElement().classList.add(this.darkClass);
        this.overlay.getContainerElement().classList.remove(this.lightClass);
      } else {
        this.overlay.getContainerElement().classList.add(this.lightClass);
        this.overlay.getContainerElement().classList.remove(this.darkClass);
      }
    });
  }
}
